import React, { useState, useEffect } from "react";
import { saveToStorage } from "./utils/cartStorage";
import TopNav from "./TopNav";
import CountryDropdown, { europeanCountries } from "./CountryDropdown";
import { useNavigate } from "react-router-dom";

export default function CheckoutPage({ cart }) {
  const navigate = useNavigate();
  const [buyerInfo, setBuyerInfo] = useState(() => {
    // Restore from localStorage if available
    const saved = localStorage.getItem("buyerInfo");

    if (saved) {
      const parsed = JSON.parse(saved);

      // If given/family missing but legacy name exists → split heuristically
      if ((!parsed.givenName || !parsed.familyName) && parsed.name) {
        const parts = parsed.name.trim().split(" ");
        parsed.givenName = parsed.givenName || parts[0];
        parsed.familyName = parsed.familyName || parts.slice(1).join(" ");
      }

      return parsed;
    }

    return {
      givenName: "",
      familyName: "",
      name: "",
      email: "",
      addressLines: ["", ""],
      zipCode: "",
      city: "",
      country: null,
    };
  });

  const [error, setError] = useState("");

  useEffect(() => {
    saveToStorage("buyerInfo", buyerInfo);
  }, [buyerInfo]);

  const handleInputChange = (field, value) => {
    setBuyerInfo((prev) => {
      const updated = { ...prev, [field]: value };

      if (field === "givenName" || field === "familyName") {
        updated.name = `${updated.givenName || ""} ${updated.familyName || ""}`.trim();
      }

      return updated;
    });
  };



  if (!cart || cart.length == 0) {
    return (
      <>
        <TopNav cart={cart} />
        <div className="pane dark_pane">
          <div className="left">
            <h2>Nothing here...</h2>
            <p>Your cart is empty</p>
          </div>
        </div>
      </>
    );
  }

  const handleAddressLineChange = (index, value) => {
    const lines = [...buyerInfo.addressLines];
    lines[index] = value;
    setBuyerInfo((prev) => ({ ...prev, addressLines: lines }));
  };

  const handleNext = () => {
    setError("");
    if (!buyerInfo.givenName || !buyerInfo.email || !buyerInfo.zipCode || !buyerInfo.city || !buyerInfo.country) {
      setError("Please fill in all required fields.");
      return;
    }

    window.location.href = "/payment";
  };

  return (
    <div>
      <TopNav cart={cart} />
      <div className="pane dark_pane">
        <div className="left_right_container">
          <div className="left">
            <h2>Shipping Information</h2>
            <div className="form-group">
              <label>Given Name</label>
              <input type="text" placeholder="Given Name" value={buyerInfo.givenName} onChange={(e) => handleInputChange("givenName", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Family Name</label>
              <input type="text" placeholder="Family Name" value={buyerInfo.familyName} onChange={(e) => handleInputChange("familyName", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="Email" value={buyerInfo.email} onChange={(e) => handleInputChange("email", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Address</label>
              <input type="text" placeholder="Address Line 1" value={buyerInfo.addressLines[0]} onChange={(e) => handleAddressLineChange(0, e.target.value)} required />
            </div>
            <div className="form-group">
              <label />
              <input type="text" placeholder="Address Line 2 (optional)" value={buyerInfo.addressLines[1]} onChange={(e) => handleAddressLineChange(1, e.target.value)} />
            </div>
            <div className="form-group">
              <label>Zipcode</label>
              <input type="text" placeholder="Zip Code" value={buyerInfo.zipCode} onChange={(e) => handleInputChange("zipCode", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>City</label>
              <input type="text" placeholder="City" value={buyerInfo.city} onChange={(e) => handleInputChange("city", e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Country</label>
              <CountryDropdown
                selectedCountry={
                  europeanCountries.find(c => c.name === buyerInfo.country)?.code ?? ""
                }
                onChange={(newCode) => {
                  const selected = europeanCountries.find(c => c.code === newCode);
                  setBuyerInfo(prev => ({ ...prev, country: selected?.name ?? "" }));
                }} />
            </div>
            <div className="form-group">

              {error && <p style={{ color: "red" }}>{error}</p>}

              <button
                className="add"
                onClick={() => navigate('/cart')}>Back</button>
              <button className="add" onClick={handleNext}>Continue</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}